import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-108" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-109" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Take a Look Inside Your Teaching System" body="Real pages. Practical resources. Less preparation for your next class." data-id="element-110" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-111" data-mp="235lwt9vjk0r7">
          <InsidePagesCarousel data-id="element-112" data-mp="238qb502q0cvl" />
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal sm:text-[1.75rem]" data-id="element-113" data-mp="1y7103kfhzz7i">
          Everything is organized to help you spend less time preparing and more time teaching.
        </p>
      </div>
    </section>;
}